import { StreamActions } from "@hotwired/turbo";

// Custom Turbo Stream action — scroll suave al target dentro del iframe
// preview del editor de paginas web. Se invoca desde el server con:
//
//   Turbo::StreamsChannel.broadcast_action_to(
//     "page_preview_X",
//     action: "scroll_to_preview",
//     target: "page_section_42"
//   )
//
// Implementacion: scroll programatico con requestAnimationFrame + easing.
// scrollIntoView({behavior: "smooth"}) no permite controlar la duracion
// y el default del browser es lento (~570ms). Aca usamos 400ms, ~30% mas
// rapido para que el editor se sienta mas reactivo.
const SCROLL_DURATION_MS = 400;

const easeInOutCubic = (t) =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

const smoothScrollTo = (targetY) => {
  const startY = window.scrollY;
  const distance = targetY - startY;
  const startTime = performance.now();

  const step = (now) => {
    const elapsed = now - startTime;
    const progress = Math.min(elapsed / SCROLL_DURATION_MS, 1);
    window.scrollTo(0, startY + distance * easeInOutCubic(progress));
    if (progress < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
};

StreamActions.scroll_to_preview = function() {
  const targetId = this.getAttribute("target");
  if (!targetId) return;
  requestAnimationFrame(() => {
    const el = document.getElementById(targetId);
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const targetY = window.scrollY + rect.top - (window.innerHeight - rect.height) / 2;
    smoothScrollTo(Math.max(0, targetY));
  });
};
